export default [
    "min_size",
    "max_size",
    "pivot_point",
    "min_size_distance",
    "max_size_distance",
    "min_visibility_distance",
    "max_visibility_distance",
    "min_fixed_direction_distance",
    "max_fixed_direction_distance",
]